import "./agent_sessions.scss";

import { onViewLoad } from "jose_modern/on_view_load";

function init() {
  // Get the modal element
  const modal = document.getElementById("session-details-modal");
  const modalContent = document.getElementById("session-details-content");

  // Function to open modal with session details
  function openSessionModal(sessionId) {
    // Show loading state
    modalContent.innerHTML =
      '<div class="has-text-centered"><div class="loader"></div><p>Loading...</p></div>';
    modal.classList.add("is-active");

    fetch(`/agent_sessions/${sessionId}/details`)
      .then((response) => response.json())
      .then((data) => {
        let html = `
          <div class="columns">
            <div class="column">
              <p><strong>ID:</strong> ${data.id}</p>
              <p><strong>Status:</strong> <span class="tag ${getStatusClass(data.status)}">${
                data.status
              }</span></p>
              <p><strong>User:</strong> ${data.user_email || "-"}</p>
              <p><strong>Agent:</strong> ${data.agent_name || "-"}</p>
              <p><strong>Method:</strong> ${data.method_name || "-"}</p>
            </div>
            <div class="column">
              <p><strong>Created:</strong> ${data.created_at}</p>
              <p><strong>Updated:</strong> ${data.updated_at}</p>
              <p><strong>Duration:</strong> ${data.duration}</p>
              <p><strong>Input Tokens:</strong> ${data.input_tokens || "-"}</p>
              <p><strong>Output Tokens:</strong> ${data.output_tokens || "-"}</p>
              <p><strong>Total Tokens:</strong> ${data.total_tokens || "-"}</p>
            </div>
          </div>
          
          <div class="tabs">
            <ul>
              <li class="is-active"><a href="#" data-tab="arguments">Arguments</a></li>
              <li><a href="#" data-tab="response">Response</a></li>
            </ul>
          </div>
          
          <div id="tab-arguments" class="tab-content">
            <pre class="has-background-light p-4" style="max-height: 300px; overflow: auto;"><code>${syntaxHighlight(
              data.arguments || {}
            )}</code></pre>
          </div>
          
          <div id="tab-response" class="tab-content" style="display: none;">
            <pre class="has-background-light p-4" style="max-height: 300px; overflow: auto;"><code>${syntaxHighlight(
              data.response || {}
            )}</code></pre>
          </div>
        `;

        modalContent.innerHTML = html;

        // Set up tab switching
        const tabs = modal.querySelectorAll(".tabs li");
        const tabContents = modal.querySelectorAll(".tab-content");

        tabs.forEach((tab) => {
          tab.addEventListener("click", (e) => {
            e.preventDefault();
            tabs.forEach((t) => t.classList.remove("is-active"));
            tab.classList.add("is-active");

            const tabName = tab.querySelector("a").getAttribute("data-tab");
            tabContents.forEach((content) => {
              content.style.display = "none";
            });
            document.getElementById(`tab-${tabName}`).style.display = "block";
          });
        });
      })
      .catch((error) => {
        console.error("Error fetching session details:", error);
        modalContent.innerHTML = `<p class="has-text-danger">Error loading session details</p>`;
      });
  }

  // Pretty print JSON with syntax highlighting
  function syntaxHighlight(json) {
    if (json === null || json === undefined) {
      return "null";
    }

    if (typeof json !== "string") {
      try {
        json = JSON.stringify(json, null, 2);
      } catch (e) {
        return "Invalid JSON";
      }
    }

    if (json.length > 100000) {
      return "JSON too large to display";
    }

    json = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/\//g, "&#x2F;");

    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
      function (match) {
        let cls = "json-number";
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = "json-key";
            // Safely handle key-value separation
            match = match.replace(/:$/, "") + ":";
          } else {
            cls = "json-string";
          }
        } else if (/true|false/.test(match)) {
          cls = "json-boolean";
        } else if (/null/.test(match)) {
          cls = "json-null";
        }
        return '<span class="' + cls + '">' + match + "</span>";
      }
    );
  }

  // Get status class for the tag
  function getStatusClass(status) {
    switch (status) {
      case "pending":
        return "is-warning";
      case "in_progress":
        return "is-info";
      case "complete":
        return "is-success";
      case "error":
        return "is-danger";
      case "not_found":
        return "is-light";
      default:
        return "is-light";
    }
  }

  // Add click event to all "View Details" buttons
  document.querySelectorAll(".view-details").forEach((button) => {
    button.addEventListener("click", function () {
      const sessionId = this.getAttribute("data-session-id");
      openSessionModal(sessionId);
    });
  });

  // Close modal when clicking background, x, or close button
  document.querySelector(".modal-background").addEventListener("click", () => {
    modal.classList.remove("is-active");
  });

  document.querySelector(".modal-card-head .delete").addEventListener("click", () => {
    modal.classList.remove("is-active");
  });

  document.querySelector(".modal-close-button").addEventListener("click", () => {
    modal.classList.remove("is-active");
  });
}

onViewLoad("agent_sessions#index", () => {
  init();
});
